import translateLanguage from 'common-translations/src/vtj/translate-language'
import { LanguageCode } from 'common/src/vtj/LanguageCode.enum'
import { SingleSelectData } from 'suomifi-ui-components'
import {
  availableTranslations,
  getNativeLanguagesByCountryCode,
} from 'todistukset-common/src/vtj/language.util'
import {
  CountryKoodistoCode,
  isCountryKoodistoCode,
} from 'todistukset-common/src/vtj/vtj-koodisto.util'
import fp from 'lodash/fp'

export const getSingleSelectLanguageDataMapper =
  (userLanguage: LanguageCode) =>
  (
    languageCode: LanguageCode
  ): { labelText: string; uniqueItemId: string } => ({
    labelText: translateLanguage({ code: languageCode, lang: userLanguage }),
    uniqueItemId: languageCode as string,
  })

export const getTranslationFormLanguageSingleSelectData = ({
  lang = LanguageCode.FI,
  suggestLanguageByCountryCode,
}: {
  lang?: LanguageCode
  suggestLanguageByCountryCode?: CountryKoodistoCode | null
}): SingleSelectData[] => {
  const convertLanguageCodeToSingleSelectData =
    getSingleSelectLanguageDataMapper(lang)

  const nativeLanguages = getNativeLanguagesByCountryCode(
    isCountryKoodistoCode(suggestLanguageByCountryCode)
      ? suggestLanguageByCountryCode
      : null
  )

  const primaryOptions = nativeLanguages.map(
    convertLanguageCodeToSingleSelectData
  ) satisfies SingleSelectData[]

  const secondaryOptions: SingleSelectData[] = fp.flow([
    fp.difference(availableTranslations),
    fp.map(convertLanguageCodeToSingleSelectData),
    fp.sortBy('label'),
  ])(nativeLanguages)

  return [...primaryOptions, ...secondaryOptions]
}
